import { defineMessages } from 'react-intl';

export default defineMessages({
  period: {
    id: 'monthCalendar.period',
    defaultMessage: '{month}, {year}'
  }
});
